import React, { useState, useEffect } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import auctionService from '../services/auctionService';
import { formatCurrency, daysRemaining, formatDate } from '../utils/validators';
import './Auctions.css';

const Auctions = () => {
  const [searchParams] = useSearchParams();
  const [auctions, setAuctions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState(searchParams.get('status') || 'all');

  useEffect(() => {
    const fetchAuctions = async () => {
      const result = await auctionService.getSellerAuctions(filter);
      if (result.success) {
        setAuctions(result.data.auctions || []);
      }
      setLoading(false);
    };

    fetchAuctions();
  }, [filter]);

  const getStatusColor = (status) => {
    switch (status) {
      case 'active': return 'badge-success';
      case 'completed': return 'badge-info';
      case 'paused': return 'badge-warning';
      case 'unsold': return 'badge-danger';
      default: return '';
    }
  };

  return (
    <div className="container py-4">
      <div className="page-header">
        <h1>My Auctions</h1>
        <Link to="/list-vehicle" className="btn btn-primary">+ List Vehicle</Link>
      </div>

      <div className="filter-tabs">
        {['all', 'active', 'completed', 'paused'].map((status) => (
          <button
            key={status}
            className={`tab ${filter === status ? 'active' : ''}`}
            onClick={() => setFilter(status)}
          >
            {status.charAt(0).toUpperCase() + status.slice(1)}
            {status === 'all' && ` (${auctions.length})`}
          </button>
        ))}
      </div>

      {loading ? (
        <div className="spinner"><div className="loading"></div>Loading...</div>
      ) : auctions.length === 0 ? (
        <div className="empty-state card">
          <p>No {filter !== 'all' ? filter : ''} auctions found</p>
          <Link to="/list-vehicle" className="btn btn-primary">Create First Auction</Link>
        </div>
      ) : (
        <div className="auctions-table">
          <table>
            <thead>
              <tr>
                <th>Vehicle</th>
                <th>Status</th>
                <th>Current Bid</th>
                <th>Bids</th>
                <th>Time Left</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {auctions.map((auction) => (
                <tr key={auction.id}>
                  <td className="vehicle-col">
                    <div>
                      <strong>{auction.vehicle.year} {auction.vehicle.make} {auction.vehicle.model}</strong>
                      <p className="text-muted">{auction.vehicle.vin}</p>
                    </div>
                  </td>
                  <td>
                    <span className={`badge ${getStatusColor(auction.status)}`}>
                      {auction.status}
                    </span>
                  </td>
                  <td>
                    <strong>{formatCurrency(auction.currentBid || auction.reservePrice)}</strong>
                  </td>
                  <td>{auction.bidCount || 0}</td>
                  <td>
                    <strong>{daysRemaining(auction.endTime)}</strong>
                  </td>
                  <td>
                    <Link to={`/auction/${auction.id}`} className="btn btn-secondary btn-small">
                      View
                    </Link>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default Auctions;
